export default __webpack_public_path__ + "static/media/circled-chevron-left.bdd8c95f.svg";